import { useMemo, useState } from 'react';
import {
  getDailyCapacityByDate,
  putDailyCapacity,
} from '../promises/getDailyCapacity';
import useApiResult from './useApiResult';

function useDailyCapacity(capacityDate: string) {
  const capacityResults = useMemo(
    () => getDailyCapacityByDate(capacityDate),
    [capacityDate]
  );
  const { loading, error, result } = useApiResult(capacityResults);

  const [addingCapacity, setAddingCapacity] = useState(false);

  async function addDailyCapacity(capacityCount: number) {
    try {
      setAddingCapacity(true);
      await putDailyCapacity(capacityCount, capacityDate);
      setAddingCapacity(false);
    } catch (e) {
      console.error(e);
      throw e;
    }
  }

  return {
    loading,
    error,
    dailyCapacity: result,
    addDailyCapacity,
    addingCapacity,
  };
}

export default useDailyCapacity;
